import { createSlice } from "@reduxjs/toolkit";

const ticketQuantityDetailSlice = createSlice({
  name: "serviceCart",
  initialState: {
    countriesProvincesInfo: [],
  },
  reducers: {
    setCountriesProvincesInfo(state, action) {
      state.countriesProvincesInfo = action.payload;
    },
    resetCountriesProvincesInfo(state) {
      state.countriesProvincesInfo = [];
    },
  },
});

export const ticketQuantityDetailActions = ticketQuantityDetailSlice.actions;

export default ticketQuantityDetailSlice;
